export enum ColorAccent {
    NEUTRAL = "neutral",
    SUCCESS = "success",
    WARNING = "warning",
    DANGER = "danger",
    INFO = "info",
    PRIMARY_BRAND = "primary-brand",
    SECONDARY_BRAND = "secondary-brand",
}
